module.exports = __webpack_public_path__ + "static/media/tally.8b6bc880.png";